<template>
    <div class="container">
        <!-- <Breadcrumb class="bread_block" /> -->
        <CommonBreadcrumb class="bread_block" /> 
        <div class="row">
            <div class="col-lg-3 col-md-4">
                <PolicyMenu />
            </div>

            <div class="col-lg-9 col-md-8">
                <PolicyCookiePolicyIndia v-if="$country.is_india" />
                <PolicyCookiePolicyUs v-else />
            </div>
        </div>
    </div>
</template>

<script setup>
    const { $country } = useNuxtApp()
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>
/* ---table----- */
.terms-box {
    margin: 2% 0;
}
.cookie_title {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #668b84;
    color: #fff;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
}
.cookie_title h5 {
    width: 20%;
    font-size: 16px;
    text-transform: capitalize;
    text-align: left;
    margin-bottom: 0;
    font-weight: 600;
    padding: 10px 15px;
}
.cookie_box {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    border-bottom: 1px solid #e2e2e2;
}
.cookie_box h6 {
    width: 20%;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #6a6161;
    margin-bottom: 0;
    padding: 15px;
    word-wrap: break-word;
}
.cookie_box h6 span {
    display: none;
}
/* ---table----- */
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #6a6161;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #6a6161;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #6a6161;
    font-size: 16px;
    font-weight: 600;
}
a{
    color: #668b84;
    text-decoration: underline;
}
@media(min-width:768px) and (max-width: 992px){
    .col-md-4, .col-md-8{
        padding-left: 0;
    }
}
@media(min-width:1024px) and (max-width: 1550px){
    .container{
        max-width: 992px;
    }
}
@media(max-width: 992px){
    .cookie_title{
        display: none;
    }
    .cookie_box h6 span {
        display: block;
        width: 50%;
        font-weight: 600;
    }
    .cookie_box h6 {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 2% 0;
        font-weight: 500;
    }
    .cookie_box {
        flex-wrap: wrap;
        border: 1px solid #ccc;
        padding: 2% 4%;
        margin-bottom: 2%;
    }
}
@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 24px;
    }
    h3, h2{
        font-size: 20px;
    }
}
</style>
